import React from 'react';
import { GridDateValueViewer } from 'components/FeaturedSpreadsheet/components';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import PurchaseDateSelect from 'pages/CapTable/fund-ownership/components/shares-ledger/components/purchase-date-select/PurchaseDateSelect';
import { PurchaseDateOption } from 'pages/CapTable/fund-ownership/components/shares-ledger/components/purchase-date-select/PurchaseDateSelect.props';

const generatePurchaseDateBaseConfig = (
  options: PurchaseDateOption[]
): {
  value: string;
  alias: string;
  width: string;
  dataEditor?: null;
  readOnly?: boolean;
  valueViewer?: (props: ICell) => React.ReactNode;
  component?: React.ReactNode;
  disableEvents?: boolean;
  forceComponent?: boolean;
  soldTable?: boolean;
  convertedTable?: boolean;
} => {
  if (options.length === 1) {
    return {
      value: 'Purchase Date',
      alias: 'purchase_date',
      width: '175px',
      dataEditor: null,
      readOnly: true,
      valueViewer: (props: ICell) => <GridDateValueViewer {...props} slashFormatted />,
    };
  }
  return {
    value: 'Purchase Date',
    alias: 'purchase_date',
    width: '175px',
    component: <PurchaseDateSelect options={options} />,
    disableEvents: true,
    forceComponent: true,
    soldTable: true,
  };
};

export default generatePurchaseDateBaseConfig;
